import { useQuery, type UseQueryResult } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { ProposalConsumptionDto } from "../dto/proposal-consumption.dto"
import { proposalConsumptionService } from "../services/proposal-consumption.service"

export default function useProposalConsumptionSelection(
  proposalId: string,
): UseQueryResult<ProposalConsumptionDto, unknown> {
  return useQuery({
    queryKey: queryKeys.proposalConsumption.selection(proposalId),
    queryFn: () => proposalConsumptionService.getSelection(proposalId),
    enabled: !!proposalId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
